import React, { useEffect, useState } from "react";
import cx from "classnames";
import {
  Link,
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { Col, Offcanvas, Row } from "react-bootstrap";
import styles from "./adminPanel.module.scss";
import { setCookie } from "../../utils/common/cookies";
import { ssoLogout } from "../../utils/sso/config";
import PROFILE_PIC from "../../assets/logo/logout.png";
import {
  Badge,
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContentText,
  IconButton,
  Popover,
} from "@mui/material";
import {
  KeyboardBackspace,
  NotificationsActive,
  NotificationsNoneOutlined,
  Replay,
} from "@mui/icons-material";
// import newCompanyLogo from "../../assets/logo/newCompanyLogo.png";
import newCompanyLogo from "../../assets/logo/cmpLogo.png";
import newCompanyLogoSmall from "../../assets/images/smallLogo.png";
import companyLogoOld from "../../assets/logo/cmpLogo.png";
import {
  dispatcherNavigations,
  packagerNavigations,
  superAdminNavigations,
} from "../../data/NavigationData";
import { connect, useDispatch } from "react-redux";
import { loginUserResponse } from "../../store/actions";
import { axiosGet } from "../../utils/common/axios";
import NotificationComponent from "../../components/customComponents/notificationComponent/NotificationComponent";

const getNavigations = (role = "") => {
  console.log(role, "role");
  switch (role) {
    case "super-admin":
      return superAdminNavigations;
    case "dispatcher":
      return dispatcherNavigations;
    case "packager":
      return packagerNavigations;

    default:
      return superAdminNavigations;
  }
};

const AdminPanel = ({ user, product = {} }) => {
  const [open, setOpen] = useState(true);
  const [show, setShow] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notificationsAnchorEl, setNotificationsAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const [showLogout, setShowLogout] = useState(false);
  const location = useLocation();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  const [subMenuSwitch, setSubMenuSwitch] = useState({});

  useEffect(() => {
    if (user?.role === "admin") {
      getOutOfStockNotification();
    }
  }, [user, product]);

  const getOutOfStockNotification = async () => {
    try {
      const { status, data } = await axiosGet("/product/out-of-stock");
      if (status === 200) {
        setNotifications(data);
      }
    } catch (error) {}
  };

  const logout = () => {
    dispatch(loginUserResponse(null));
    ssoLogout();
  };
  const notificationsCount = notifications?.length ?? 0;
  const hasNotifications = notificationsCount > 0;
  const isNotificationsOpen = Boolean(notificationsAnchorEl);
  const notificationsPopoverId = isNotificationsOpen
    ? "notifications-popover"
    : undefined;

  const handleNotificationsClick = (event) => {
    if (isNotificationsOpen) {
      setNotificationsAnchorEl(null);
      return;
    }

    setNotificationsAnchorEl(event.currentTarget);
  };

  const handleNotificationsClose = () => {
    setNotificationsAnchorEl(null);
  };
  console.log(user);

  if (!user?.id) {
    return <Navigate to="/login" replace />;
  }

  console.log(user, "user");
  return (
    <div>
      <div
        className={cx(styles.sidebar, {
          [styles.close]: !open,
        })}
      >
        <div className={styles["logo-details"]}>
          <img src={newCompanyLogoSmall} alt="" className={styles.image} />
          <span className={styles["logo_name"]}>Kriha Commerce</span>
        </div>
        <ul className={styles["nav-links"]}>
          {getNavigations(user?.role).map((navigation) => {
            if (!navigation.subMenu) {
              return (
                <Link
                  to={navigation.link}
                  className={styles.link}
                  key={navigation.id}
                >
                  <li key={navigation.id}>
                    <div>
                      {/* <i className={navigation.icon}></i> */}
                      <div className={styles.iconContainer}>
                        <span class="material-symbols-outlined">
                          {navigation.icon}
                        </span>
                      </div>
                      <span className={styles["link_name"]}>
                        {navigation.title}
                      </span>
                    </div>
                    <ul className={cx(styles["sub-menu"], styles.blank)}>
                      <li>
                        <div className={styles["link_name"]}>
                          {navigation.title}
                        </div>
                      </li>
                    </ul>
                  </li>
                </Link>
              );
            }

            return (
              <Link
                to={navigation.link}
                className={styles.link}
                key={navigation.id}
              >
                <li
                  key={navigation.id}
                  className={cx({
                    [styles.showMenu]: subMenuSwitch[navigation.id] || false,
                  })}
                >
                  <div className={styles["icon-link"]}>
                    <div>
                      <div className={styles.iconContainer}>
                        <span class="material-symbols-outlined">
                          {navigation.icon}
                        </span>
                      </div>
                      <span className={styles["link_name"]}>
                        {navigation.title}
                      </span>
                    </div>
                    <i
                      onClick={() => {
                        setSubMenuSwitch({
                          ...subMenuSwitch,
                          [navigation.id]: !subMenuSwitch[navigation.id],
                        });
                      }}
                      className={cx("bx", "bxs-chevron-down", styles.arrow)}
                    ></i>
                  </div>
                  <ul className={styles["sub-menu"]}>
                    <Link to={navigation.link} className={styles.link}>
                      <li>
                        <div className={styles["link_name"]}>
                          {navigation.title}
                        </div>
                      </li>
                    </Link>
                    {navigation.subMenu.map((subMenuItem) => {
                      return (
                        <Link
                          to={subMenuItem.link}
                          className={styles.link}
                          key={subMenuItem.id}
                        >
                          <li>
                            <div>{subMenuItem.title}</div>
                          </li>
                        </Link>
                      );
                    })}
                  </ul>
                </li>
              </Link>
            );
          })}
          <li>
            <div className={styles["profile-details"]}>
              <div className={styles["profile-content"]}>
                <img src={user?.imageUrl || PROFILE_PIC} alt="profileImg" />
              </div>
              <div className={styles["name-job"]}>
                <div className={styles["profile_name"]}>
                  {(user?.fullName || user?.username)?.slice(0, 10)}
                  {/* {user?.last_name} */}
                </div>
                <div className={styles.job}>{user?.role}</div>
              </div>
              <i
                onClick={() => setShowLogout(true)}
                className="bx bx-log-out"
                style={{ color: "white" }}
              ></i>
            </div>
          </li>
        </ul>
      </div>
      {/* For Mobile View */}
      <Offcanvas show={show} onHide={handleClose} className={styles.offCanvas}>
        <Offcanvas.Header closeButton closeVariant="white">
          {/* <Offcanvas.Title>Offcanvas</Offcanvas.Title> */}
          <div className={styles["logo-details"]}>
            <img src={newCompanyLogoSmall} alt="" className={styles.image} />
            <span className={styles["logo_name"]}>Kriha Commerce</span>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body className={styles.offCanvasBody}>
          <ul className={styles["nav-links"]}>
            {getNavigations(user?.role).map((navigation) => {
              if (!navigation.subMenu) {
                return (
                  <Link
                    to={navigation.link}
                    className={styles.link}
                    onClick={handleClose}
                    key={navigation.id}
                  >
                    <li key={navigation.id}>
                      <div>
                        <div className={styles.iconContainer}>
                          <span class="material-symbols-outlined">
                            {navigation.icon}
                          </span>
                        </div>
                        <span className={styles["link_name"]}>
                          {navigation.title}
                        </span>
                      </div>
                      {/* <ul className={cx(styles["sub-menu"], styles.blank)}>
                        <li>
                          <div className={styles["link_name"]}>
                            {navigation.title}
                          </div>
                        </li>
                      </ul> */}
                    </li>
                  </Link>
                );
              }

              return (
                <Link
                  to={navigation.link}
                  className={styles.link}
                  key={navigation.id}
                >
                  <li
                    key={navigation.id}
                    className={cx({
                      [styles.showMenu]: subMenuSwitch[navigation.id] || false,
                    })}
                  >
                    <div className={styles["icon-link"]}>
                      <div>
                        <div className={styles.iconContainer}>
                          <span class="material-symbols-outlined">
                            {navigation.icon}
                          </span>
                        </div>
                        <span className={styles["link_name"]}>
                          {navigation.title}
                        </span>
                      </div>
                      <i
                        onClick={() => {
                          setSubMenuSwitch({
                            ...subMenuSwitch,
                            [navigation.id]: !subMenuSwitch[navigation.id],
                          });
                        }}
                        className={cx("bx", "bxs-chevron-down", styles.arrow)}
                      ></i>
                    </div>
                    <ul className={styles["sub-menu"]}>
                      <Link to={navigation.link} className={styles.link}>
                        <li>
                          <div className={styles["link_name"]}>
                            {navigation.title}
                          </div>
                        </li>
                      </Link>
                      {navigation.subMenu.map((subMenuItem) => {
                        return (
                          <Link
                            to={subMenuItem.link}
                            className={styles.link}
                            key={subMenuItem.id}
                          >
                            <li>
                              <div>{subMenuItem.title}</div>
                            </li>
                          </Link>
                        );
                      })}
                    </ul>
                  </li>
                </Link>
              );
            })}
            <li>
              <div className={styles["profile-details"]}>
                <div className={styles["profile-content"]}>
                  <img
                    src={user?.profile_pic_url || PROFILE_PIC}
                    alt="profileImg"
                  />
                </div>
                <div className={styles["name-job"]}>
                  <div className={styles["profile_name"]}>
                    {(user?.fullName || user?.username)}
                    {/* {user?.last_name} */}
                  </div>
                  <div className={styles.job}>{user?.role}</div>
                </div>
                <i
                  onClick={() => setShowLogout(true)}
                  className="bx bx-log-out"
                ></i>
              </div>
            </li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
      <section className={styles["home-section"]}>
        <Row className={styles["home-content"]}>
          {" "}
          {/*Navbar */}
          <Col
            onClick={() => setOpen(!open)}
            className={cx("bx", "bx-menu", styles["bx-menu"])}
          ></Col>
          <Col
            onClick={handleShow}
            className={cx("bx", "bx-menu", styles["bx-menu2"])}
          ></Col>
          <Col
            className={styles.text}
            style={{
              fontSize: (user?.fullName || user?.username)?.length > 10 ? "18px" : "35px",
              textTransform: "capitalize",
            }}
          >
            Welcome, {(user?.fullName || user?.username)}
          </Col>
          <Col className={styles.muiIconContainer}>
            {user?.role === "admin" && (
              <IconButton
                classes={{ root: styles.iconButton }}
                aria-describedby={notificationsPopoverId}
                onClick={handleNotificationsClick}
                size="large"
              >
                <Badge
                  badgeContent={notificationsCount}
                  color="error"
                  overlap="rectangular"
                  invisible={!hasNotifications}
                >
                  <>
                    {hasNotifications ? (
                      <NotificationsActive
                        classes={{ root: styles.muiIconActive }}
                        color="error"
                      />
                    ) : (
                      <NotificationsNoneOutlined
                        classes={{ root: styles.muiIcon }}
                      />
                    )}
                  </>
                </Badge>
              </IconButton>
            )}

            <Popover
              id={notificationsPopoverId}
              open={isNotificationsOpen}
              anchorEl={notificationsAnchorEl}
              onClose={handleNotificationsClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                sx: {
                  boxShadow: "none",
                  background: "transparent",
                  overflow: "visible",
                  mt: 1,
                  p: 0,
                },
              }}
            >
              <NotificationComponent
                notifications={notifications}
                onClose={handleNotificationsClose}
              />
            </Popover>
          </Col>
          {location?.pathname !== "/" && (
            <Col className={styles.backButtonContainer}>
              <Button
                startIcon={<KeyboardBackspace />}
                onClick={() => window.history.go(-1)}
                variant="contained"
                txtClr={"#FFFFFF"}
                style={{ background: "black" }}
                classes={{ contained: styles.backButton }}
              >
                back
              </Button>
            </Col>
          )}
          {/* <Col className={styles.backButtonContainer}>
            {location.pathname !== "/admin-panel" ? (
              <ButtonGroup className={styles.buttonGroup}>
                <Button
                  startIcon={<Replay />}
                  onClick={() => window.location.reload()}
                  variant="contained"
                  classes={{ contained: styles.backButton }}
                  color="warning"
                >
                  refresh
                </Button>
                <Button
                  startIcon={<KeyboardBackspace />}
                  onClick={() => window.history.go(-1)}
                  variant="contained"
                  color="error"
                  classes={{ contained: styles.backButton }}
                >
                  go back
                </Button>
              </ButtonGroup>
            ) : (
              ""
            )}
          </Col> */}
        </Row>
        <div className={styles.viewPort}>
          <Outlet />
        </div>
      </section>
      <Dialog open={showLogout} onClose={() => setShowLogout(false)}>
        <DialogContentText style={{ fontWeight: "600", padding: "20px" }}>
          Are you sure you wanna logout ?
        </DialogContentText>
        <DialogActions
          style={{ display: "flex", justifyContent: "center", padding: "20px" }}
        >
          <Button variant="outlined" onClick={() => setShowLogout(false)}>
            Cancel
          </Button>
          <Button variant="contained" onClick={logout}>
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.login?.user,
    product: state.product?.product,
  };
};

export default connect(mapStateToProps, null)(AdminPanel);
